import axios from "axios";
import { setAlert } from "./alert";
import { setErrorsList } from "./errors";
import { logout } from "./auth";
import { removeErrors } from "reducers/errors";

import {
  loadingSchoolsList,
  schoolListUpdated,
  schoolSearchParametersUpdate,
  schoolCreated,
  loadCurrentSchool,
  resetAppToken,
  schoolError,
  loadingOnSchoolSubmit,
  schoolUpdated,
  schoolDeleted,
  schoolStateList,
} from "reducers/schoolReducer";

export const getSchoolsList = (params) => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    const query = params.query ? params.query : "";
    params.query = query;
    config.params = params;

    dispatch(loadingSchoolsList());
    const res = await axios.get("/api/admin/schools/list", config);

    dispatch(schoolSearchParametersUpdate(params));

    dispatch(schoolListUpdated(res.data.response[0]));
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          schoolError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const createSchool = (formData) => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    dispatch(loadingSchoolsList());

    const res = await axios.post("/api/admin/schools", formData, config);
    if (res.data.status === true) {
      dispatch(schoolCreated(res.data.response));

      return res.data;
    } else {
      const errors = res.data.errors;
      if (errors) {
        dispatch(schoolError());
        dispatch(setAlert(res.data.message, "danger"));

        errors.forEach((error) => {
          dispatch(setErrorsList(error.msg, error.param));
        });
      }
    }
    return res.data ? res.data : { status: false };
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          schoolError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const getSchoolById = (id) => async (dispatch) => {
  dispatch(removeErrors());
  dispatch(loadingOnSchoolSubmit());
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.get(`/api/admin/schools/${id}`, config);

    dispatch(loadCurrentSchool(res.data.response));
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    // console.log(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          schoolError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const updateSchool =
  (formData, school_id, navigate) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.put(
        `/api/admin/schools/${school_id}`,
        formData,
        config
      );

      if (res.data.status === true) {
        await dispatch(schoolUpdated(res.data.response));
        await dispatch(loadCurrentSchool(res.data.response));
        dispatch(setAlert(res.data.message, "success"));
        return res.data ? res.data : { status: false };
      } else {
        const errors = res.data.errors;
        if (errors.length) {
          dispatch(schoolError());
          dispatch(setErrors(errors));
        }
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch(
            schoolError({
              msg: err.response.statusText,
              status: err.response.status,
            })
          );
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

export const deleteSchool = (school_id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    await axios.delete(`/api/admin/schools/${school_id}`, config);

    dispatch(schoolDeleted(school_id));
    dispatch(setAlert("School deleted", "success"));
  } catch (err) {
    // console.log(err);
    err.response &&
      dispatch(
        schoolError({
          msg: err.response.statusText,
          status: err.response.status,
        })
      );
  }
};

export const getStatesList = () => async (dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    var res = await axios.get(`/api/common/state/list`, config);

    if (res.data.status === true) {
      await dispatch(schoolStateList(res.data.response));
    }
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    console.log(err);
  }
};

// reset errors
export const removeSchoolErrors = () => async (dispatch) => {
  dispatch(removeErrors());
};

// Dispatch Reset store
export const resetComponentStore = () => async (dispatch) => {
  await dispatch(resetAppToken());
};

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch(schoolError());
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

export const cancelSave = (navigate) => async (dispatch) => {
  dispatch(removeErrors());
  navigate("/admin/schools");
};
